import { useLayoutEffect } from 'react';

interface UseBodyScrollLockOptions {
  selector?: string;
}

const BODY_SCROLL_LOCK_CLASSES = [
  '!overflow-hidden',
  '!relative',
  '!w-full',
  '!h-full',
] as const;

const lockCountByTarget = new Map<HTMLElement, number>();

export const useBodyScrollLock = (
  enabled: boolean,
  options?: UseBodyScrollLockOptions,
) => {
  const selector = options?.selector;

  useLayoutEffect(() => {
    if (typeof document === 'undefined' || !enabled) return;

    let target = document.body;

    if (selector) {
      const optionTarget = document.getElementById(selector);

      if (optionTarget) {
        target = optionTarget;
      }
    }

    const { classList } = target;

    classList.add(...BODY_SCROLL_LOCK_CLASSES);
    lockCountByTarget.set(target, (lockCountByTarget.get(target) ?? 0) + 1);

    return () => {
      const remainingLockCount = (lockCountByTarget.get(target) ?? 1) - 1;

      if (remainingLockCount > 0) {
        lockCountByTarget.set(target, remainingLockCount);

        return;
      }

      lockCountByTarget.delete(target);
      classList.remove(...BODY_SCROLL_LOCK_CLASSES);
    };
  }, [enabled, selector]);
};
